import { render } from "./eduSection.vue?vue&type=template&id=30955014&scoped=true"
import script from "./eduSection.vue?vue&type=script&lang=js"
export * from "./eduSection.vue?vue&type=script&lang=js"

import "./eduSection.vue?vue&type=style&index=0&id=30955014&scoped=true&lang=css"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30955014"]])

export default __exports__